<script>
  import { onMount } from "svelte";
  import Chart from "chart.js";

  export let chartData = { labels: [], datasets: [] };

  let chartInstance = null;

  onMount(async () => {
    const ctx = document.getElementById("piloto-peso-chart");
    if (!ctx) return;

    const config = {
      type: "line",
      data: {
        labels: chartData.labels || [],
        datasets: chartData.datasets || [{
          label: 'Total Peso por Fecha',
          backgroundColor: '#4c51bf',
          borderColor: '#4c51bf',
          data: [],
          fill: false,
          tension: 0.4
        }]
      },
      options: {
        maintainAspectRatio: false,
        responsive: true,
        title: {
          display: false,
          text: "Peso de Pilotos",
        },
        legend: {
          labels: {
            fontColor: "rgba(0,0,0,.4)",
          },
          align: "end",
          position: "bottom",
        },
        tooltips: {
          mode: "index",
          intersect: false,
          callbacks: {
            label: function(context) {
              const label = context.dataset && context.dataset.label ? context.dataset.label : '';
              const value = context.parsed && context.parsed.y != null ? context.parsed.y.toLocaleString() : '';
              return label ? `${label}: ${value} lbs` : `${value} lbs`;
            }
          }
        },
        hover: {
          mode: "nearest",
          intersect: true,
        },
        scales: {
          xAxes: [
            {
              ticks: {
                fontColor: "rgba(0,0,0,.7)",
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Fecha",
                fontColor: "white",
              },
              gridLines: {
                display: false,
                borderDash: [2],
                borderDashOffset: [2],
                color: "rgba(33, 37, 41, 0.3)",
                zeroLineColor: "rgba(0, 0, 0, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
          yAxes: [
            {
              ticks: {
                fontColor: "rgba(0,0,0,.7)",
                callback: function(value) {
                  return value.toLocaleString() + ' lbs';
                }
              },
              display: true,
              scaleLabel: {
                display: false,
                labelString: "Peso (lbs)",
                fontColor: "white",
              },
              gridLines: {
                borderDash: [3],
                borderDashOffset: [3],
                drawBorder: false,
                color: "rgba(0, 0, 0, 0.15)",
                zeroLineColor: "rgba(33, 37, 41, 0)",
                zeroLineBorderDash: [2],
                zeroLineBorderDashOffset: [2],
              },
            },
          ],
        },
      },
    };

    chartInstance = new Chart(ctx, config);
  });

  // Update chart when data changes
  $: if (chartInstance && chartData) {
    chartInstance.data.labels = chartData.labels || [];
    chartInstance.data.datasets = chartData.datasets || [];
    chartInstance.update();
  }
</script>

<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
  <div class="rounded-t mb-0 px-4 py-3 bg-gray-100">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full max-w-full flex-grow flex-1">
        <h6 class="uppercase text-gray-600 mb-1 text-xs font-semibold">
          Análisis de Peso
        </h6>
        <h2 class="text-gray-800 text-xl font-semibold">
          Evolución del Peso por Fecha
        </h2>
      </div>
    </div>
  </div>
  <div class="p-4 flex-auto">
    <!-- Chart -->
    <div class="relative h-350-px">
      <canvas id="piloto-peso-chart"></canvas>
    </div>
  </div>
</div> 